import { usePermissions } from '@customerio/hydra-permissions/react';
import { PageLoader } from '@customerio/pluma-components/react';
import { useCurrentWorkspace } from '../context/current-workspace';
import { workspaceRootUrl } from '@/utils/navigation';
import { selectOnboardingEntryRedirect, useOnboardingSignals } from '@/features/onboarding';
import { SafeNavigate } from '@/services/router/safe-navigate';
import { useBillingLandingHref } from '@/features/billing';

/**
 * Where a returning user lands. The onboarding check runs first because it
 * replaces the workspace destination entirely.
 */
export default function Index() {
  const currentWorkspace = useCurrentWorkspace();
  const { hasPermission } = usePermissions();
  const { isLoading, ...signals } = useOnboardingSignals();
  const billingLandingHref = useBillingLandingHref();

  if (isLoading) {
    return <PageLoader />;
  }

  const onboardingRedirect = selectOnboardingEntryRedirect(signals);
  if (onboardingRedirect != null) {
    return <SafeNavigate to={onboardingRedirect} options={{ shouldReplaceHistoryEntry: true }} />;
  }

  if (currentWorkspace == null) {
    if (hasPermission('account/billing/view') === true) {
      return <SafeNavigate to={billingLandingHref} options={{ shouldReplaceHistoryEntry: true }} />;
    }
    return <SafeNavigate to="settings" options={{ shouldReplaceHistoryEntry: true }} />;
  }

  const path = `${workspaceRootUrl(currentWorkspace.id)}${window.location.search}`;
  return <SafeNavigate to={path} options={{ shouldReplaceHistoryEntry: true }} />;
}
